import { Group, Scale } from '../utils/UNSAFE_visTypes/chart';
import { getLineAreaSegments } from '#utils/PRIVATE_chartUtils/utils';
import { AreaSeries } from '#PRIVATE_LineAreaComponents/AreaSeries';
import { useUser } from '#hooks/UNSAFE_useUser';

type VariedAreaRefObjProps = {
  id: string;
  xScale: Scale;
  yScale: Scale;
  items: { low: number; high: number }[];
  orientation?: 'horizontal' | 'vertical';
  areaColor?: string;
  areaOpacity?: number;
  lineWidth?: number;
  accessibleLabel?: string;
  groups?: Group[];
  xStartIndex?: number;
  xEndIndex?: number;
  isLog?: boolean;
  seriesIndex?: number;
  activeId?: string;
};

export function VariedAreaRefObj({
  id,
  xScale,
  yScale,
  items,
  orientation = 'horizontal',
  areaColor,
  areaOpacity,
  groups = [],
  xStartIndex = 0,
  xEndIndex = 0,
  isLog = false,
  seriesIndex = 0,
  activeId,
  accessibleLabel
}: VariedAreaRefObjProps) {
  const { direction } = useUser();
  const isHorizontal = orientation === 'horizontal';
  const isRtl = direction === 'rtl';

  if (!items || items.length === 0 || !xScale || !yScale) {
    return null;
  }

  // Get coordinates for top and bottom of the area
  const topCoords = getLineAreaSegments(
    yScale,
    xScale,
    items.map((item) => item.high),
    xStartIndex,
    xEndIndex,
    isLog,
    groups,
    0,
    (_, gIndex) => ({ id: `${id}_top_${gIndex}`, ...items[gIndex] })
  );

  const bottomCoords = getLineAreaSegments(
    yScale,
    xScale,
    items.map((item) => item.low),
    xStartIndex,
    xEndIndex,
    isLog,
    groups,
    0,
    (_, gIndex) => ({ id: `${id}_bottom_${gIndex}`, ...items[gIndex] })
  ).flat();

  return (
    <>
      <AreaSeries
        id={id}
        activeId={activeId}
        accessibleLabel={accessibleLabel}
        yScale={yScale}
        lineType="straight"
        color={areaColor}
        variant="refArea"
        isHorizontal={isHorizontal}
        areaColorOpacity={areaOpacity}
        isBottomSegmentCurved={false}
        bottomCoords={bottomCoords}
        lineSegments={topCoords}
        isLog={isLog}
        isHighlighted={false}
        seriesIndex={seriesIndex}
        isRtl={isRtl}
      />
    </>
  );
}
